(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvSelector', drvSelector);

    drvSelector.$inject = [];

    /**
     * @ngdoc directive
     * @name drvSelector
     * 
     * @description
     * Select control which has two sections supporting 'transclusion-like' functionality.
     * These are <selected-template> and <dropdown-item-template>.
     * 
     * # Scope Properties
     * {string} label - The label/name to be shown for the control. Optional.
     * {string} icon - The icon to be shown for the control. Optional.
     * {string} iconColour - The icon colour to be shown for the control. Optional.
     * {object} value - The selected value. This will be an array when in 'multi-select mode'.
     * {array} items - List of items to be shown in the control.
     * {string} placeHolder - The label/name to be shown in the control when no value has been selected. Optional.
     * {bool} disabled - Disables the control. Optional.
     * {bool} ngRequired - Value must be selected. Optional.
     * {bool} disableClear - Disallows the controls value to be cleared. This only works for 'single-select mode'. Optional.
     * {bool} multiple - Sets the control to run in 'multi-select mode'. Optional.
     * {object} footerDetails - Contains two properties relating to the select control footer. This only works for 'multiple-select mode'. Optional.
     *              showSMSOnlyIsVisible - Shows the 'Show SMS Only' checkbox
     *              showSMSOnly - Value of the 'Show SMS Only' checkbox contained within the select control footer
     *              showMoreIsVisible - Shows the 'Show More' checkbox
     *              showMore - Value of the 'Show More' checkbox contained within the select control footer
     * {function} onChange - Callback which is invoked when the ng model value has changed. Optional
     * {array/string} valueProperties - Can be array for multiple properties or string for a single property.
     *                                  They will be used to construct a custom value object, this is the format which will be used with value.
     *                                  If not supplied, the unmodified item will be used. Optional.
     * {array} searchProperties - Array of property references (property name as string) used to override the default search functionality (full item or Name + Description). Optional.
     * {function} taggingCallback - This is needed to allow tagging/adding new items. Callback is provided with a string, which should be transformed into an item of the appropriate format and returned via the method.
     *                              The returned item is then appended to the value property.
     *                              The callback is also responsible for adding the item to the items list. This only works for 'multi-select mode'. Optional.
     * {function} taggingEnabled - Is tagging (adding new items) allowed? This only works for 'multi-select mode'. Optional.
     */
    function drvSelector() {
        var directive = {
            controller: drvSelectorCtrl,
            controllerAs: 'drvSelCtrl',
            restrict: 'E',
            scope: true,
            bindToController: {
                label: '@?',
                icon: '@?',
                iconColour: '@?',
                value: '=',
                items: '<?',
                placeHolder: '@?',
                disabled: '<?',
                ngRequired: '<?',
                disableClear: '<?',
                multiple: '<?',
                footerDetails: '=?',
                onChange: '&?',
                valueProperties: '<?',
                searchProperties: '<?',
                taggingCallback: '&?',
                taggingEnabled: '<?'
            },
            template: getTemplate
        };

        function getTemplate(tElement) {
            var dropdownItemTemplate = tElement[0].querySelector('dropdown-item-template').innerHTML;
            var selectedTemplate = tElement[0].querySelector('selected-template').innerHTML;

            return '<div layout="row" layout-wrap style="padding-top: 11px; padding-bottom: 11px;">' +
                '   <div class="material-label-fake" ng-class="{ mandatory : drvSelCtrl.ngRequired, invalid : drvSelCtrl.invalid }" flex="100">' +
                '       <drv-icon ng-if="drvSelCtrl.icon" icon="drvSelCtrl.icon" colour="drvSelCtrl.iconColour"></drv-icon>' +
                '       <span>{{drvSelCtrl.label}}</span>' +
                '   </div>' +
                '   <ui-select name="{{drvSelCtrl.label}}" ng-if="!drvSelCtrl.multiple" ng-model="drvSelCtrl.selectedValue" theme="select2" ng-required="drvSelCtrl.ngRequired" ng-disabled="drvSelCtrl.disabled" backspace-reset="drvSelCtrl.allowClear || false" flex="100" on-remove="drvSelCtrl.updateValue(drvSelCtrl.selectedValue)" on-select="drvSelCtrl.updateValue(drvSelCtrl.selectedValue)" append-to-body="true">' +
                '       <ui-select-match allow-clear="{{drvSelCtrl.allowClear || \'false\'}}" placeholder="{{drvSelCtrl.placeHolder}}"><span style="display:none;">{{item = $select.selected}}</span>' +
                selectedTemplate +
                '       </ui-select-match>' +
                '       <ui-select-choices repeat="item in drvSelCtrl.getItems($select.search)">' +
                dropdownItemTemplate +
                '       </ui-select-choices>' +
                '   </ui-select>' +
                '   <ui-select name="{{drvSelCtrl.label}}" ng-if="drvSelCtrl.multiple && !drvSelCtrl.taggingEnabled" ng-model="drvSelCtrl.selectedValue" theme="select2" ng-required="drvSelCtrl.ngRequired" ng-disabled="drvSelCtrl.disabled" on-remove="drvSelCtrl.updateValue(drvSelCtrl.selectedValue)" on-select="drvSelCtrl.updateValue(drvSelCtrl.selectedValue)" multiple flex="100" append-to-body="true" footer-details="drvSelCtrl.footerDetails">' +
                '       <ui-select-match><span style="display:none;">{{item = $item}}</span>' +
                selectedTemplate +
                '       </ui-select-match>' +
                '       <ui-select-choices repeat="item in drvSelCtrl.getItems($select.search)">' +
                dropdownItemTemplate +
                '       </ui-select-choices>' +
                '   </ui-select>' +
                '   <ui-select name="{{drvSelCtrl.label}}" ng-if="drvSelCtrl.multiple && drvSelCtrl.taggingEnabled" ng-model="drvSelCtrl.selectedValue" theme="select2" ng-required="drvSelCtrl.ngRequired" ng-disabled="drvSelCtrl.disabled" on-remove="drvSelCtrl.updateValue(drvSelCtrl.selectedValue)" on-select="drvSelCtrl.updateValue(drvSelCtrl.selectedValue)" multiple flex="100" append-to-body="true" tagging="drvSelCtrl.taggingCallback()" tagging-label="false" footer-details="drvSelCtrl.footerDetails">' +
                '       <ui-select-match placeholder="{{drvSelCtrl.placeHolder}}"><span style="display:none;">{{item = $item}}</span>' +
                selectedTemplate +
                '       </ui-select-match>' +
                '       <ui-select-choices repeat="item in drvSelCtrl.getItems($select.search)">' +
                dropdownItemTemplate +
                '       </ui-select-choices>' +
                '   </ui-select>' +
                '</div>';
        }

        return directive;
    }

    drvSelectorCtrl.$inject = ['$scope', '$timeout'];

    function drvSelectorCtrl($scope, $timeout) {
        /* jshint validthis:true */
        var drvSelCtrl = this;
        drvSelCtrl.selectedValue = null;
        drvSelCtrl.initialised = false;
        drvSelCtrl.getNameText = getNameText;
        drvSelCtrl.getDescriptionText = getDescriptionText;
        drvSelCtrl.getItems = getItems;
        drvSelCtrl.updateValue = updateValue;
        drvSelCtrl.getSelectedItem = function (item) {
            return item;
        };
        Object.defineProperty(drvSelCtrl, 'invalid', {
            get: function () {
                return (drvSelCtrl.ngRequired &&
                    ((!drvSelCtrl.multiple && (_.isNil(drvSelCtrl.selectedValue) || drvSelCtrl.selectedValue === '')) ||
                    (drvSelCtrl.multiple && (_.isNil(drvSelCtrl.selectedValue) || !angular.isArray(drvSelCtrl.selectedValue) || drvSelCtrl.selectedValue.length < 1))));
            }
        });
        Object.defineProperty(drvSelCtrl, 'allowClear', {
            get: function () { return (_.isNil(drvSelCtrl.disableClear) || !drvSelCtrl.disableClear); }
        });

        activate();

        function activate() {
            // Watching the value to ensure the internal value is sycned with any external model changes.
            $scope.$watch('drvSelCtrl.value', function (newVal, oldVal) {
                if (!drvSelCtrl.initialised) {
                    if (!_.isNil(newVal) && !_.isNil(drvSelCtrl.items) && drvSelCtrl.items.length > 0) {
                        $timeout(function () {
                            drvSelCtrl.initialised = true;
                            updateSelectedValue();
                        });
                    }
                } else if (!angular.equals(newVal, oldVal)) {
                    $timeout(function () {
                        updateSelectedValue();
                    });
                }
            }, true);

            // Need to watch the items incase these are loaded after the value is supplied, otherwise the internal value may not be correctly set.
            $scope.$watch('drvSelCtrl.items', function (newVal, oldVal) {
                if (!drvSelCtrl.initialised) {
                    if (!_.isNil(newVal) && newVal.length > 0 && !_.isNil(drvSelCtrl.value)) {
                        $timeout(function () {
                            drvSelCtrl.initialised = true;
                            updateSelectedValue();
                        });
                    }
                } else if (!angular.equals(newVal, oldVal)) {
                    $timeout(function () {
                        updateSelectedValue();
                    });
                }
            }, true);
        }

        /*
         * Updates the ng model value to match the internal value.
         */
        function updateValue(newValue) {
            if (_.isNil(newValue)) {
                drvSelCtrl.value = null;
            } else {
                if (!drvSelCtrl.multiple) {
                    if (!angular.equals(drvSelCtrl.value, getValueFromItem(newValue))) {
                        drvSelCtrl.value = getValueFromItem(newValue);
                    }
                } else {
                    var selectedValues = _.map(drvSelCtrl.selectedValue, function (selectedValue) {
                        return getValueFromItem(selectedValue);
                    });

                    if (!angular.equals(drvSelCtrl.value, selectedValues)) {
                        drvSelCtrl.value = selectedValues;
                    }
                }
            }

            // Timeout so the value will be digested before running the callback function.
            if (!_.isNil(drvSelCtrl.onChange)) {
                $timeout(function () {
                    drvSelCtrl.onChange();
                });
            }
        }

        /*
         * Updates the selected value to match the ng model value.
         */
        function updateSelectedValue() {
            if (_.isNil(drvSelCtrl.value)) {
                drvSelCtrl.selectedValue = null;
            } else {
                if (!drvSelCtrl.multiple) {
                    var selectedValue = _.find(drvSelCtrl.items, function (item) {
                        return getValueFromItem(item) === drvSelCtrl.value;
                    });


                    if (!angular.equals(selectedValue, drvSelCtrl.selectedValue)) {
                        drvSelCtrl.selectedValue = selectedValue;
                    }
                } else {
                    var selectedValues = [];

                    angular.forEach(drvSelCtrl.value, function (value) {
                        var listItem = _.find(drvSelCtrl.items, function (item) {
                            var itemValue = getValueFromItem(item);
                            return angular.equals(itemValue, getValueFromItem(value));
                        });

                        if (!_.isNil(listItem)) {
                            selectedValues.push(listItem);
                        } else {
                            selectedValues.push(value);
                            drvSelCtrl.items.push(value);
                        }
                    });

                    if (!angular.equals(selectedValues, drvSelCtrl.selectedValue)) {
                        drvSelCtrl.selectedValue = selectedValues;
                    }
                }
            }
        }

        /*
         * Gets the text to be shown for the first line of the item.
         *
         * @returns {string} The text to be shown for the first line of an item.
         */
        function getNameText(item) {
            var result = '';

            if (!_.isNil(item)) {
                if (!_.isNil(item.Name)) {
                    result = item.Name;
                } else if (!_.isNil(item.Value)) {
                    result = item.Value;
                }
            }

            return result;
        }

        /*
         * Gets the text to be shown for the second line of the item.
         *
         * @returns {string} The text to be shown for the second line of an item.
         */
        function getDescriptionText(item) {
            var result = '';

            if (!_.isNil(item)) {
                if (!_.isNil(item.Description)) {
                    result = item.Description;
                }
            }

            return result;
        }

        /*
         * Gets a list of items which have been filtered by the supplied search text.
         *
         * @returns {array} An array of items which match the supplied search text
         */
        function getItems(search) {
            var result = [];

            if (!_.isNil(search) && search !== '') {
                if (_.isNil(drvSelCtrl.searchProperties) || drvSelCtrl.searchProperties === '') {
                    result = _.filter(drvSelCtrl.items, function (item) {
                        return ((!_.isNil(item.Name) && item.Name.toLowerCase().includes(search.toLowerCase())) ||
                            (!_.isNil(item.Description) && item.Description.toLowerCase().includes(search.toLowerCase())) ||
                            (!_.isNil(item) && _.isNil(item.Name) && _.isNil(item.Description) && item.toString().toLowerCase().includes(search.toLowerCase())));
                    });
                } else {
                    result = _.filter(drvSelCtrl.items, function (item) {
                        var addToArray = false;

                        angular.forEach(drvSelCtrl.searchProperties, function (property) {
                            if (!_.isNil([item].concat(property.split('.')).reduce(function (a, b) { return a ? a[b] : undefined; }))) {
                                if ([item].concat(property.split('.')).reduce(function (a, b) { return a ? a[b] : undefined; }).toString().toLowerCase().includes(search.toLowerCase())) {
                                    addToArray = true;
                                }
                            }
                        });

                        return addToArray;
                    });
                }

            } else {
                result = _.filter(drvSelCtrl.items, function (item) { return true; });
            }

            if (!angular.equals(getItems.items, result)) {
                getItems.items = result;
            }

            return getItems.items;
        }

        /*
         * Gets the 'value' from the supplied item. This is used for converting a list item into the format stored on ngModel.
         *
         * @returns {object} the items value in a form compatible with the ngModel.
         */
        function getValueFromItem(item) {
            var result = item;

            if (!_.isNil(item) && !_.isNil(drvSelCtrl.valueProperties) && drvSelCtrl.valueProperties !== '') {
                if (angular.isArray(drvSelCtrl.valueProperties)) {
                    result = {};

                    angular.forEach(drvSelCtrl.valueProperties, function (property) {
                        result[property] = item[property];
                    });
                } else {
                    result = item[drvSelCtrl.valueProperties];
                }
            }

            return result;
        }
    }
})();